/**
 * Banner / BB Banner — video play/pause control
 * @param {string} sectionId - Shopify section.id
 */
function initBbBannerVideo(sectionId) {
  if (!sectionId) return;

  const section = document.querySelector('.banner-video--' + sectionId);
  if (!section) return;

  const video = section.querySelector('.banner__video, .bb-banner__video, .video-play-pause');
  const control = section.querySelector(
    '[data-bb-banner-video-control], [data-banner-video-control]'
  );
  const controlLabel = section.querySelector(
    '[data-bb-banner-video-control-label], [data-banner-video-control-label]'
  );
  const controlStatus = section.querySelector(
    '[data-bb-banner-video-control-status], [data-banner-video-control-status]'
  );

  if (!video || !control || !controlLabel || !controlStatus) return;

  const setControlState = (isPlaying) => {
    control.dataset.state = isPlaying ? 'pause' : 'play';
    control.setAttribute('aria-label', isPlaying ? 'Pause banner video' : 'Play banner video');
    control.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    controlLabel.textContent = isPlaying ? 'Pause' : 'Play';
    controlStatus.textContent = isPlaying ? 'Video playing' : 'Video paused';
  };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (prefersReducedMotion.matches) {
    video.pause();
    video.removeAttribute('autoplay');
    setControlState(false);
  } else {
    setControlState(!video.paused);
  }

  prefersReducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      video.pause();
      setControlState(false);
    }
  });

  control.addEventListener('click', () => {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  });

  video.addEventListener('play', () => setControlState(true));
  video.addEventListener('pause', () => setControlState(false));
}

window.initBbBannerVideo = initBbBannerVideo;
